import React,{useEffect,useState} from 'react';
import Header from '../../components/common/Header';
import {useNavigate,useLocation} from 'react-router-dom';
import { Link } from 'react-router-dom';
import { getReferralDetail, getSelectedDetail} from '../../actions/StudentAction';
import ReferFriendLink from '../../components/Student/ReferFriendLink';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';
import ReferBanner from '../../assets/images/refer-banner.png'
import MobileReferBanner from '../../assets/images/mob-ref-banner.png'
import moment from 'moment';
import ModalPopup from '../../components/common/ModalPopup'
import TermsAndConditions from '../../components/Student/TermsAndConditions';

const ReferToFriend = (props) => {
    const navigate = useNavigate();
    const location=useLocation();
    const [profileDetail, setProfileDetail] = useState({});
    const [referralList,setRefferalList] = useState([]);

    // useEffect(() => {
    //   window.gtag("config", "UA-185641939-1", {
    //   page_title: location.pathname,
    //   page_path:location.pathname,
    //   })
    //   }, [location]);
    
    //   useEffect(() => {
    //     window.gtag("config", "AW-10846823673", {
    //     page_title: location.pathname,
    //     page_path:location.pathname,
    //     })
    //   }, [location]);

    useEffect(async() => {
        sessionStorage.getItem('userDetail') ?  navigate('/refer-a-friend') : navigate('/login');
        if(location&& location.state!==null){
          const {detail}=location.state
          const userId=detail.id
          getSelectedDetail(userId).then((res) => {
              setProfileDetail(res.data);
            });
      }


    },[location.state]);



    useEffect(async() => {
      await getReferralDetail(profileDetail.id !== undefined && profileDetail.id )
        .then(res => {
            setRefferalList(res.data)
        })


    },[profileDetail.id])

  
    return (
        <>
            <Header  detail={profileDetail} />
            <section className='content-section mt-5'>
            <div className='container'>
            <PageBreadcrumbs profileDetailLink={profileDetail} pagename="Refer a friend" colFull/>
              {/* <div className='row mb-2'>
                <div className='col-lg-12'>
                  <h4>Refer to your friend</h4>
                </div>
              </div> */}
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='card-header p-0 banner_contentWrap'>
                      <img src={ReferBanner} className="img-fluid d-none d-md-block" alt="Refer Friend"/>
                      <img src={MobileReferBanner} className="img-fluid d-block d-md-none" alt="Refer Friend"/>
                      <h2>Refer a Friend</h2>
                      <p>You can refer multiple friends from different countries</p>
                  </div>
                  <div className='box px-4 py-4'>
                    
                    <ReferFriendLink  detail={profileDetail}/>
                    <h6 className='mt-2 ps-1'>By sharing this link you agree to accept our <Link to="javascript:void(0)"  data-bs-toggle="modal" data-bs-target="#showTermsConditions">Terms & Conditions</Link>.</h6>
                  {/* <ReferToFriendForm  onSubmit={onSubmit} detail={profileDetail}/> */}

                  <div className='reffered_friendList_contain mt-5 border-top pt-4'>
                    <h4 className='mb-2'>No. of Registration ({referralList!==undefined && referralList.length})</h4>
                    <div className='table-responsive'>
                      <table className='table table-striped table-hover'>
                        <tbody>
                            {referralList!==undefined && referralList.map((item)=>(
                              <tr key={item.id}>
                              <td>{item.email}</td>
                              <td>{moment(item.created_at).format('DD MMM YYYY')}</td>
                            </tr>
                            ))}
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                  </div>
                </div>
              </div>

            </div>

          </section>

          <ModalPopup id="showTermsConditions" size="modal-xl" className="termsConditonsPopup" modalTitle="By sharing this link you agree to accept our terms and conditions." >
                <TermsAndConditions/>
          </ModalPopup>
        </>
    )
}

export default ReferToFriend;
